import Localization from 'lib/localization';

export default {
  lxPagePrivacyPolicyTabsMenuSectionListItemOne() {
    return Localization.get('bumblesite@privacy.tabs.item1');
  },
  lxPagePrivacyPolicyTabsMenuSectionListItemTwo() {
    return Localization.get('bumblesite@privacy.tabs.item2');
  },
  lxPagePrivacyPolicyTabsMenuSectionListItemThree() {
    return Localization.get('bumblesite@privacy.tabs.item3');
  },
  lxPagePrivacyPolicyTabsMenuSectionListItemFour() {
    return Localization.get('bumblesite@privacy.tabs.item4');
  },
  lxPagePrivacyPolicyTabsMenuSectionListItemFive() {
    return Localization.get('bumblesite@privacy.tabs.item5');
  },
  lxPagePrivacyPolicyTabsMenuSectionListItemSix() {
    return Localization.get('bumblesite@privacy.tabs.item6');
  },
  lxPagePrivacyPolicyTabsMenuSectionListItemSeven() {
    return Localization.get('bumblesite@privacy.tabs.item7');
  },
  lxPagePrivacyPolicyTabsMenuSectionListItemEight() {
    return Localization.get('bumblesite@privacy.tabs.item8');
  },
};
